import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeEventFilter } from '../../../../store/actions/sportEvents';
import Categories from '../../../shared/Events/Filters/Categories/Categories';
import Leagues from '../../../shared/Events/Filters/Leagues/Leagues';
import Periods from '../../../shared/Events/Filters/Periods/Periods';
import Orders from '../../../shared/Events/Filters/Orders/Orders';
import { changeFavoritesEventType } from '../../../../store/actions/favorites';
import { EVENT_FILTER_OPTIONS } from '../../../../constants/event-filters';

const PreMatchFilters = () => {
    const dispatch = useDispatch();

    const categories = useSelector(state => state.sportEvents.filters.categories) || [];
    const leagues = useSelector(state => state.sportEvents.filters.leagues) || [];

    const onCategoriesChange = value => {
        const newLeagues = leagues.map(league => {
            if (league.id === EVENT_FILTER_OPTIONS.leagues.all.id) {
                return { ...league, selected: true };
            }

            return { ...league, selected: false };
        });

        dispatch(changeEventFilter({ key: 'leagues', value: newLeagues }));
    };

    const onLeaguesChange = value => {
        if (value.categoryId) {
            const newCategories = categories.map(category => {
                if (category.id === value.categoryId) {
                    return { ...category, selected: true };
                }

                return { ...category, selected: false };
            });

            dispatch(changeEventFilter({ key: 'categories', value: newCategories }));
        }
    };

    const onOrderChange = value => {
        dispatch(changeFavoritesEventType(value.value));
    };

    return (
        <div className={'filter-area'}>
            <div className={'filter-grid'} style={{ width: '80%' }}>
                <Categories onChange={onCategoriesChange} />
            </div>
            <div className={'filter-grid'}>
                <Leagues onChange={onLeaguesChange} />
            </div>
            <div className={'filter-grid'} style={{ width: '60%' }}>
                <Periods />
            </div>
            <div className={'filter-grid'} style={{ width: '60%' }}>
                <Orders onChange={onOrderChange} />
            </div>
            <div className={'filter-grid'} style={{ width: '90px', minWidth: '90px' }} />
        </div>
    );
};

export default PreMatchFilters;
